import { startOfMonth } from 'date-fns';
import { getStartMonthDate } from '../../../../util';
import { getCustomCalendarPeriodEndDate } from '../../../../util/customCalendarPeriods';
import { ReportSettingCommitmentState } from '../Commitment';
import { PITValidationData } from './validateReportSettingPITStateForReportType';
import { formatDateByLocale } from '../../../../util/dateHelpers';

export const validateReportSettingPITStateCommitment = ({
  pitAsOfDate,
  reportSettingState,
  customCalendarSettings,
  localePreference,
}: PITValidationData): string[] => {
  const { shortStartDate } = reportSettingState as ReportSettingCommitmentState;
  const isCustomCalendarEnabled =
    customCalendarSettings?.isCustomCalendarEnabled;

  const reportStartDate = isCustomCalendarEnabled
    ? getCustomCalendarPeriodEndDate(shortStartDate, customCalendarSettings)
    : getStartMonthDate(shortStartDate);
  const today = new Date();
  const formattedText = isCustomCalendarEnabled ? 'period/year' : 'month/year';

  const errs = [];
  if (pitAsOfDate < reportStartDate) {
    errs.push(
      `As of date cannot occur before Report Start Date of ${formatDateByLocale(
        reportStartDate,
        localePreference,
      )}. Please adjust dates or disable Point in Time.`,
    );
  }
  if (startOfMonth(today) < reportStartDate) {
    errs.push(
      `As of date cannot be used if today's ${formattedText} is less than selected start ${formattedText}. Please adjust dates or disable Point in Time.`,
    );
  }

  return errs;
};
